const mainNavigation = document.querySelector('.main-navigation');

if (mainNavigation) {
  const buffer = 4;
  const lockDuration = 300;

  let navbarSecondary;
  let secondaryHeight = 0;
  let navigationHeight = 0;
  let topNavigationHeight = 0;
  let downThreshold = 0;
  let upThreshold = 0;

  let lastScrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  let isScrolled = mainNavigation.classList.contains('is-scrolled');

  let lockUntil = 0;
  let metricsTimeoutId = null;

  // rAF state
  let ticking = false;
  let lastKnownScrollY = lastScrollTop;

  const recalcNavigationMetrics = () => {
    navbarSecondary = mainNavigation.querySelector('.navbar-secondary');
    secondaryHeight = navbarSecondary ? navbarSecondary.offsetHeight : 0;
    navigationHeight = mainNavigation.offsetHeight;
    topNavigationHeight = navigationHeight - secondaryHeight;

    downThreshold = navigationHeight;
    upThreshold = topNavigationHeight;
  };

  const setStickyState = (shouldBeScrolled) => {
    if (shouldBeScrolled) {
      mainNavigation.classList.add('is-scrolled');
      document.body.classList.add('sticky-header');
      isScrolled = true;
    } else {
      mainNavigation.classList.remove('is-scrolled');
      document.body.classList.remove('sticky-header');
      isScrolled = false;
    }
  };

  const syncNavToScrollPosition = (scrollTop) => {
    if (!isScrolled && scrollTop > downThreshold + buffer) {
      setStickyState(true);
    } else if (isScrolled && scrollTop < upThreshold - buffer) {
      setStickyState(false);
    }
  };

  const schedulePostAnimationUpdate = () => {
    lockUntil = Date.now() + lockDuration;

    if (metricsTimeoutId !== null) {
      clearTimeout(metricsTimeoutId);
    }

    metricsTimeoutId = window.setTimeout(() => {
      recalcNavigationMetrics();

      const currentScrollTop =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;

      syncNavToScrollPosition(currentScrollTop);
      recalcNavigationMetrics(); // in case state changed

      metricsTimeoutId = null;
      lockUntil = 0;
    }, lockDuration);
  };

  const handleScrollCore = () => {
    const scrollTop = Math.round(lastKnownScrollY);
    const scrollingDown = scrollTop > lastScrollTop;
    const scrollingUp = scrollTop < lastScrollTop;

    const now = Date.now();
    const lockActive = now < lockUntil;

    if (!lockActive) {
      if (!isScrolled && scrollingDown && scrollTop > downThreshold + buffer) {
        setStickyState(true);
        schedulePostAnimationUpdate();
      } else if (
        isScrolled &&
        scrollingUp &&
        scrollTop < upThreshold - buffer
      ) {
        setStickyState(false);
        schedulePostAnimationUpdate();
      }
    }

    lastScrollTop = scrollTop;
  };

  const onScroll = () => {
    // Only cheap operations here
    lastKnownScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;

    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => {
        handleScrollCore();
        ticking = false;
      });
    }
  };

  // Initial setup
  recalcNavigationMetrics();
  const initialScrollTop =
    window.scrollY ||
    window.pageYOffset ||
    document.documentElement.scrollTop;
  syncNavToScrollPosition(initialScrollTop);
  lastScrollTop = initialScrollTop;
  lastKnownScrollY = initialScrollTop;

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    recalcNavigationMetrics();
    const currentScrollTop =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    syncNavToScrollPosition(currentScrollTop);
  });
}
